let overlay;

// create a container and set the full-size image as its background
function createOverlay(image) {
  const overlayImage = document.createElement('img');
  overlayImage.setAttribute('src', `${image.src}`);
  overlay = document.createElement('div');
  prepareOverlay(overlay, overlayImage);

  image.style.opacity = '50%';
  toggleLoadingSpinner(image);

  overlayImage.onload = () => {
    toggleLoadingSpinner(image);
    image.parentElement.insertBefore(overlay, image);
    image.style.opacity = '100%';
  };

  return overlay;
}

function prepareOverlay(container, image) {
  container.setAttribute('class', 'image-magnify-full-size');
  container.setAttribute('aria-hidden', 'true');
  container.style.backgroundImage = `url('${image.src}')`;
  container.style.backgroundColor = 'var(--gradient-background)';
}

function toggleLoadingSpinner(image) {
  const loadingScope =
    image.closest('.product__modal-opener') ||
    image.closest('.product__media') ||
    image.parentElement?.parentElement;
  const loadingSpinner = loadingScope?.querySelector(`.loading__spinner`);
  if (loadingSpinner) {
    loadingSpinner.classList.toggle('hidden');
  }
}

function moveWithHover(image, event, zoomRatio) {
  // calculate mouse position
  const ratio = image.height / image.width;
  const container = image.getBoundingClientRect();
  const clientX = event?.clientX || container.left + container.width / 2;
  const clientY = event?.clientY || container.top + container.height / 2;
  const xPosition = clientX - container.left;
  const yPosition = clientY - container.top;
  const xPercent = `${xPosition / (image.clientWidth / 100)}%`;
  const yPercent = `${yPosition / ((image.clientWidth * ratio) / 100)}%`;

  // determine what to show in the frame
  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlay.style.backgroundSize = `${image.width * zoomRatio}px`;
}

function magnify(image, zoomRatio) {
  document.querySelectorAll('.image-magnify-full-size').forEach((existingOverlay) => existingOverlay.remove());
  const overlay = createOverlay(image);
  overlay.onclick = () => overlay.remove();
  overlay.onmousemove = (event) => moveWithHover(image, event, zoomRatio);
  overlay.onmouseleave = () => overlay.remove();
}

function enableZoomOnHover(zoomRatio) {
  const images = document.querySelectorAll('.image-magnify-hover');
  images.forEach((image) => {
    image.onclick = (event) => {
      magnify(image, zoomRatio);
      moveWithHover(image, event, zoomRatio);
    };
  });

  document.querySelectorAll('.product__modal-opener--image .product__media-zoom-hover').forEach((button) => {
    if (button.dataset.magnifyInFrameBound === 'true') return;
    button.dataset.magnifyInFrameBound = 'true';

    button.addEventListener(
      'click',
      (event) => {
        const opener = button.closest('.product__modal-opener--image');
        const image = opener?.querySelector('.image-magnify-hover');
        if (!image) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        magnify(image, zoomRatio);
        moveWithHover(image, event, zoomRatio);
      },
      { capture: true }
    );
  });
}

enableZoomOnHover(2);
